export const pick = <T extends object, K extends keyof T>(
    obj: T,
    ...keys: readonly K[]
) => {
    const result = {} as Pick<T, K>;

    for (const key of keys) {
        if (key in obj) {
            result[key] = obj[key];
        }
    }

    return result;
};

export const omit = <T extends object, K extends keyof T & string>(
    obj: T,
    ...keys: readonly K[]
) => {
    const result = {} as Omit<T, K>;

    (Object.keys(obj) as (keyof T)[]).forEach((key) => {
        if (!keys.includes(key as K)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (result as any)[key as K] = obj[key];
        }
    });

    return result;
};

export const omitIf = <T extends object>(
    obj: T,
    predicate: (value: T[keyof T], key: keyof T) => boolean,
) => {
    const result = {} as Partial<T>;

    (Object.keys(obj) as (keyof T)[]).forEach((key) => {
        if (!predicate(obj[key], key)) {
            result[key] = obj[key];
        }
    });

    return result;
};
